import { FC } from 'react';

import { StyledPopupMain } from './index.styles';

const PopupMain: FC<{
  className?: string;
  children: JSX.Element | JSX.Element[];
  refElement?: React.RefObject<HTMLDivElement>;
}> = ({ children, className, refElement }) => {
  return (
    <StyledPopupMain className={className} ref={refElement ? refElement : undefined}>
      {children}
    </StyledPopupMain>
  );
};

export default PopupMain;
